/** The only place `fetch` is called — every JSON content file (scenes, artifacts, knowledge,
 *  asset manifest) loads through this one helper. */
export async function fetchJson(url: string): Promise<unknown> {
  const response = await fetch(url);
  if (!response.ok) throw new Error(`Failed to fetch "${url}": ${response.status} ${response.statusText}`);
  return response.json();
}
